<template>
  <Modal
    ref="createAnnotationSetModal"
    :title="'Create New Annotation Set'"
  >
    <!-- <template #modal-header /> -->
    <template #modal-main>
      <div class="settings container">
        <div class="row mb-3">
          <div class="col-12 settings__control-group">
            <label>Name</label>
            <input
              ref="annSetName"
              v-model="name"
              class="select"
              type="text"
            >
          </div>
        </div>
        <div class="row">
          <div class="col-12 settings__control-group">
            <label>Description</label>
            <textarea
              v-model="description"
              rows="4"
              cols="50"
            />
          </div>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <div class="footer">
        <button
          class="button modal-action-button"
          @click="createAnnotationSet"
        >
          Create New Set
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import Modal from '@/components/Modal.vue';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

const $toast = useToast();

export default {
  name: 'CreateAnnotationSetModal',
  components: {
    Modal,
  },
  props: {
    datasetId: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  emits: ['annotation-set-created', 'annotation-set-created-error', 'closed'],
  data() {
    return {
      name: 'annotations',
      description: '',
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
  },
  created() {
    this.dataConnect = new DatastoreConnect(this.$store.state.enterpriseServerUrl);
  },
  methods: {
    showModal() {
      this.$refs.createAnnotationSetModal.showModal();
      this.$nextTick(() => {
        this.$refs.annSetName.focus();
      });
    },
    closeModal() {
      this.name = 'annotations';
      this.description = '';
      this.$emit('closed');
      this.$refs.createAnnotationSetModal.closeModal();
    },
    async createAnnotationSet() {
      if (!this.name) {
        $toast.open({
          queue: true,
          message: `Failed to create annotation set: Missing name`,
          type: 'error',
          position: 'top',
          dismissible: true,
        });
        return;
      }
      const resp = await this.dataConnect.createAnnotationSet({
        name: this.name,
        description: this.description,
        operator: this.user.username,
        origin_x: 0,
        origin_y: 0,
        dataset_id: this.datasetId,
      })
        .catch((error) => {
          $toast.open({
            queue: true,
            message: `Failed to create annotation set: ${error}`,
            type: 'error',
            position: 'top',
            dismissible: true,
          });
        });
      if (resp.error || !resp.result) {
        $toast.open({
          queue: true,
          message: `Failed to create annotation set: ${resp.error.message}`,
          type: 'error',
          position: 'top',
          dismissible: true,
        });
        this.$emit('annotation-set-created-error', resp.error);
      } else {
        this.name = '';
        this.description = '';
        this.closeModal();
        this.$emit('annotation-set-created', resp.result);
      }
    },
  },
};

</script>

<style lang="scss" scoped>
.settings {
  padding: 0.75rem 3rem;
  min-width: 420px;
}

.footer {
  display: flex;
  flex-direction: row;
  padding: 0.75rem 3rem;
  justify-content: flex-end;
}

</style>
